import React from 'react';

import { FormControl } from '../../../facturotopia';

const BussinesRulesForm = ({ data = {}, item, rules, onChange }) => {
  const handleOnChange = (event) => {
    onChange({
      ...event,
    });
  };

  const { name, type, placeholder = '', options = [] } = item;

  return (
    <div>
      {['select'].includes(type) && (
        <div>
          <FormControl
            type={type}
            name={name}
            placeholder={placeholder}
            label={item.label}
            value={data[name]}
            rules={rules[name]}
            options={options}
            onChange={handleOnChange}
          />
        </div>
      )}

      {!['select'].includes(type) && (
        <div>
          <FormControl
            type={type}
            name={name}
            placeholder={placeholder}
            label={item.label}
            value={data[name]}
            rules={rules[name]}
            onChange={handleOnChange}
          />
        </div>
      )}
    </div>
  );
};

export default BussinesRulesForm;
